// extracted by mini-css-extract-plugin
module.exports = {"group":"chip_group__fad1Q","phAnimation":"chip_phAnimation__UBr_D"};